<template>
    <app-layout>
        <template #icon>
            <div class="flex h-10 w-10 items-center justify-center">
                <svg
                    width="30"
                    height="30"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                >
                    <path
                        stroke="url(#paint0_linear_68_19)"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_68_19"
                            x1="4.56256"
                            y1="4.33394"
                            x2="24.9101"
                            y2="26.2819"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#FF8D47" />
                            <stop offset="0.147634" stop-color="#FF7447" />
                            <stop offset="0.454086" stop-color="#FF4247" />
                            <stop offset="0.636926" stop-color="#E92A5B" />
                            <stop offset="0.740367" stop-color="#DD1C67" />
                            <stop offset="0.842991" stop-color="#D31071" />
                            <stop offset="1" stop-color="#CF0283" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
        </template>
        <template #title> {{ $t("workflows.title") }} </template>
        <template #description> {{ $t("workflows.description") }}</template>
        <template #actions>
            <CreateWorkflowModal :integrations="integrations">
                <AddButton
                    :paid-only="true"
                    feature="custom_workflow"
                    data-cy="create-new-workflow"
                >
                    {{ $t("workflows.new_workflow") }}</AddButton
                >
            </CreateWorkflowModal>
        </template>

        <div class="px-4 pt-8 sm:px-6">
            <workflow
                v-for="defaultWorkflow in defaultWorkflows"
                :key="defaultWorkflow.id"
                :workflow="defaultWorkflow"
                :event-types="eventTypes"
            />
            <workflow
                v-for="workflow in notDefaultWorkflows"
                :key="workflow.id"
                :workflow="workflow"
                :event-types="eventTypes"
            />
        </div>
    </app-layout>
</template>

<script lang="ts" setup>
import AppLayout from "../../../../Layouts/AppLayout.vue";
import { computed } from "vue";
import AddButton from "../Atomic/AddButton.vue";
import CreateWorkflowModal from "./components/CreateWorkflowModal.vue";
import Workflow from "./components/Workflow.vue";
import type { Workflow as WorkflowType } from "./components/Workflow.vue";
import { PropType } from "vue";

const props = defineProps({
    workflows: {
        type: Array as PropType<WorkflowType[]>,
        required: true,
    },
    eventTypes: {
        type: Array,
        required: true,
    },

    integrations: {
        type: Array,
        required: true,
    },
});

const defaultWorkflows = computed(() => {
    return props.workflows?.filter(function (workflow: WorkflowType) {
        return workflow.default;
    });
});
const notDefaultWorkflows = computed(() => {
    return props.workflows?.filter(function (workflow: WorkflowType) {
        return !workflow.default;
    });
});
</script>
